import React from 'react';
import styled from 'styled-components';
import up from '../../assets/up.png';
import Plasticpollution from '../../components/Plasticpollution/Plasticpollution';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;

  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;
  height: 50vh;
`;

class CardPlasticpollution extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Plasticpollution/>      
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {up}
   metricsm="8.0 Million tons per year"
   diagnosis="Our sustained dependence on plastic has made it the most prevalent type of marine debris in our ocean and Great Lakes. This debris threatens marine habitats, and can can harm or kill an animal via ingestion or entanglement."
   prediction="Plastic consumption can both starve and contaminate marine ecosystems which regulate our global climate, and provide food to human populations."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardPlasticpollution;
